import { render, staticRenderFns } from "./postLinkedin.vue?vue&type=template&id=f78c4fb2"
import script from "./postLinkedin.vue?vue&type=script&lang=js"
export * from "./postLinkedin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f78c4fb2')) {
      api.createRecord('f78c4fb2', component.options)
    } else {
      api.reload('f78c4fb2', component.options)
    }
    module.hot.accept("./postLinkedin.vue?vue&type=template&id=f78c4fb2", function () {
      api.rerender('f78c4fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postLinkedin.vue"
export default component.exports